import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const SunmiPOS = dynamic(() => import("../../components/hardware-partners/Sunmi/DesktopSunmi"), {
    loading: () => <Loading />,
}
);

const MobileSunmiPOS = dynamic(() => import("../../components/hardware-partners/Sunmi/MobileSunmi"), {
    loading: () => <Loading />,
}
);

const iminPosSystem = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Sunmi POS Machines Compatible With QueueBuster POS Software</title>
                <meta name="description" content="Explore Sunmi POS hardware devices fully compatible with QueueBuster POS software. Enhance your business operations with seamless integration and superior performance." />
                <link rel="canonical" href="https://queuebuster.co/pos-hardware-partners/sunmi" />
                <link rel="alternate" href="https://queuebuster.co/pos-hardware-partners/sunmi" hrefLang="en-us" />
                <meta property="og:title" content="Sunmi POS Hardware Devices Compatible With QueueBuster POS Software" />
                <meta property="og:description" content="Explore Sunmi POS hardware devices fully compatible with QueueBuster POS software. Enhance your business operations with seamless integration and superior performance." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/sunmi.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-hardware-partners/sunmi" />
                
            </Head>
            {mobileView ? <MobileSunmiPOS /> : <SunmiPOS />}
        </>
    )
}

export default iminPosSystem